import { render } from "./slidermanagement.vue?vue&type=template&id=06062957&scoped=true"
import script from "./slidermanagement.vue?vue&type=script&lang=js"
export * from "./slidermanagement.vue?vue&type=script&lang=js"

import "./slidermanagement.vue?vue&type=style&index=0&id=06062957&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06062957"]])

export default __exports__